import axios from 'axios';

const API_BASE = 'https://canvasoft.com:8487/canvamanager';

export interface FavoritoRequest {
  idCliente: number;
  idImagen: number;
  secuencia: number;
}

export const favoritesService = {
  async getFavorites(idCliente: number) {
    const response = await axios.get(`${API_BASE}/market/favorites/${idCliente}`);
    return response.data;
  },

  async addFavorite(request: FavoritoRequest) {
    const response = await axios.post(`${API_BASE}/market/favorites`, null, {
      params: {
        idCliente: request.idCliente,
        idImagen: request.idImagen
      }
    });
    return response.data;
  },

  async removeFavorite(idCliente: number, idImagen: number) {
    await axios.delete(`${API_BASE}/market/favorites`, {
      params: { idCliente, idImagen }
    });
  },

  async checkFavorite(idCliente: number, idImagen: number) {
    const response = await axios.get(`${API_BASE}/market/favorites/check`, {
      params: { idCliente, idImagen }
    });
    return response.data;
  }
};